export default {
  getAccountingCodeList(state) {
    return state.accountingCodeList
  },
  getAccountingCode(state) {
    return state.accountingCode
  }
}
